import script from "./ProductDeal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDeal.vue?vue&type=script&setup=true&lang=js"

import "./ProductDeal.vue?vue&type=style&index=0&id=18d4f684&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18d4f684"]])

export default __exports__